export enum Currency {
  EUR = 'EUR',
  JPY = 'JPY'
}

export const BASE_CURRENCY = Currency.EUR

export const currencyOptions = [
  { label: 'EUR — Euro', value: Currency.EUR },
  { label: 'JPY — Japanese Yen', value: Currency.JPY }
]

export const EXCHANGE_RATE_PATTERN = /^\d+(\.\d{1,6})?$/

export const FIXED_FEE_PATTERN = /^\d+(\.\d{1,2})?$/

export const WHOLE_AMOUNT_PATTERN = /^\d+(\.0+)?$/
